import cn from 'classnames';

export interface BadgeProps {
  closable?: boolean;
  onClose?: (e: any) => void;
  value: string;
}

export function Badge({ closable = false, onClose, value }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center py-0.5 rounded-full text-xs font-medium bg-rum-100 text-rum-700 whitespace-nowrap',
        {
          'pl-2 pr-0.5': closable,
          'px-2': !closable,
        },
      )}
    >
      {value}
      {closable && (
        <button
          onClick={onClose}
          type="button"
          className="flex-shrnk-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-rum-400 hover:bg-rum-200 hover:text-rum-500 focus:outline-none focus:bg-rum-500 focus:text-white"
        >
          <span className="sr-only">Remove tag</span>
          <svg
            className="h-2 w-2"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 8 8"
          >
            <path
              strokeLinecap="round"
              strokeWidth="1.5"
              d="M1 1l6 6m0-6L1 7"
            />
          </svg>
        </button>
      )}
    </span>
  );
}

export default Badge;
